export enum StepProgressState {
  ACTIVE,
  COMPLETED,
  ERROR,
}

export enum ThirdPartyAncillariesProvider {
  CAR_TRAWLER_RENTAL = 'CAR_TRAWLER_RENTAL',
  CAR_TRAWLER_TRANSFER = 'CAR_TRAWLER_TRANSFER',
  CAR_TRAWLER_SMARTBLOCK = 'CAR_TRAWLER_SMARTBLOCK',
  EXPEDIA_HOTEL = 'EXPEDIA_HOTEL',
  EXPEDIA_ACTIVITIES = 'EXPEDIA_ACTIVITIES',
}

export enum ExpediaHotelOrigin {
  WIDGET_HOTEL_TAB = 'Widget-Hotel-Tab',
  TRIP_OVERVIEW = 'Trip-Overview',
  THIRD_PARTY_ANCILLARIES = 'Third-Party-Ancillaries',
  ANCILLARY_CONFIRMATION = 'Ancillary-Confirmation',
}

export enum CarTrawlerNativeClientID {
  MMB_TRIP_DETAILS_FIRST_24H = 410441,
  MMB_TRIP_DETAILS_DEEP_LINK = 410458,
  MMB_HOTELS_AND_CAR_RENTALS = 410475,
  MMB_AIRPORT_TRANSFERS_DEEPLINK = 411223,
  MMB_ANCILLARY_CONFIRMATION_PAGE = 410645,
  MMB_CHECK_IN_CONFIRMATION = 410611,
}

export enum CarTrawlerBrowserClientID {
  MMB_TRIP_DETAILS_FIRST_24H = 608790,
  MMB_TRIP_DETAILS_DEEP_LINK = 398694,
  MMB_HOTELS_AND_CAR_RENTALS = 398065,
  MMB_AIRPORT_TRANSFERS_DEEPLINK = 396807,
  MMB_ANCILLARY_CONFIRMATION_PAGE = 402825,
  MMB_CHECK_IN_CONFIRMATION = 403743,
}

export enum TouchPoint {
  MMB_OVERVIEW = 'MMB_OVERVIEW',
  MMB_HOTEL_AND_EXPERIENCES = 'MMB_HOTEL_AND_EXPERIENCES',
  MMB_CONFIRMATION = 'MMB_CONFIRMATION',
  CHECK_IN_CONFIRMATION = 'CHECK_IN_CONFIRMATION',
}

export type CarTrawlerClientID = CarTrawlerNativeClientID | CarTrawlerBrowserClientID;
